import { useTranslation } from "react-i18next";
import { Card, ErrorBox, Skeleton } from "../../components/ui";
import { useTrainingNeeds } from "../../lib/api";
import { coverageHeat } from "./shared";

/** Training-needs analysis: the capability gap report (WP-23.1). */
export default function Needs({ company }: { company?: string }) {
  const { t } = useTranslation();
  const tna = useTrainingNeeds(company, true);

  return (
    <div data-ld-needs>
      {/* training needs (TNA) */}
      <Card className="mt-6 overflow-hidden">
        <div className="border-b border-brand-grey-light px-4 py-3">
          <h2 className="font-heading text-base font-semibold">{t("ld.tna.title")}</h2>
          <span className="text-xs text-brand-grey">{t("ld.tna.hint")}</span>
        </div>
        {tna.isLoading ? <div className="p-4"><Skeleton className="h-16" /></div> : tna.isError ? <div className="p-4"><ErrorBox error={tna.error} onRetry={() => void tna.refetch()} /></div> : tna.data && (
          <>
            {tna.data.designations_with_targets === 0 ? <div className="p-6 text-center text-sm text-brand-grey">{t("ld.tna.noTargets")}</div> : (
              <>
                {tna.data.priorities.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 px-4 py-3">
                    {tna.data.priorities.map((p) => <span key={p.skill} className="rounded-full border border-brand-grey-light px-2 py-0.5 text-[11px]">{p.skill} · {t("ld.tna.priorityHint", { n: p.employees })}</span>)}
                  </div>
                )}
                {tna.data.needing_training.length === 0 ? <div className="p-6 text-center text-sm text-brand-grey">{t("ld.tna.noGap")}</div> : (
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-[#F6F8FA] text-left text-[11px] uppercase tracking-wide text-brand-grey">
                        <tr><th className="px-4 py-2">{t("wf.search.employee")}</th><th className="px-4 py-2">{t("ld.tna.missing")}</th><th className="px-4 py-2 text-right">{t("ld.tna.coverage")}</th></tr>
                      </thead>
                      <tbody>
                        {tna.data.needing_training.slice(0, 30).map((r) => (
                          <tr key={r.name} className="border-t border-brand-grey-light">
                            <td className="px-4 py-2"><div className="font-semibold">{r.employee_name}</div><div className="text-[11px] text-brand-grey">{r.designation} · {r.company}</div></td>
                            <td className="px-4 py-2 text-xs">{r.gap.missing.join(", ")}</td>
                            <td className={`px-4 py-2 text-right font-semibold tabular-nums ${coverageHeat(r.gap.coverage_pct)}`}>{r.gap.coverage_pct} %</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </Card>
    </div>
  );
}
